import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';

export const exportSimpleXls = (fileName: string, xlsData: any[], merges: any[] = []) => {
  const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  const wb = XLSX.utils.book_new();
  const ws = XLSX.utils.aoa_to_sheet(xlsData);
  ws['!merges'] = merges;
  XLSX.utils.book_append_sheet(wb, ws, 'sheet 1');
  const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
  const responseBlob = new Blob([excelBuffer], { type: fileType });
  FileSaver.saveAs(responseBlob, fileName);
};
